import axios from 'axios';

const api = axios.create({ baseURL: '/api', headers: { 'Content-Type': 'application/json' } });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('rgpd-token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const auth = {
  getConfig: () => api.get('/auth/config'),
  microsoftStart: () => api.get('/auth/microsoft/start'),
  microsoftCallback: (code, state) => api.post('/auth/microsoft/callback', { code, state }),
  getMe: () => api.get('/auth/me'),
};

// Console interne (JWT).
export const console_ = {
  stats: () => api.get('/rgpd/stats'),
  identifiants: () => api.get('/rgpd/identifiants'),
  rechercher: (q) => api.get('/rgpd/identifiants/recherche', { params: { q } }),
  fiche: (id) => api.get(`/rgpd/identifiants/${id}`),
  demander: (id, payload) => api.post(`/rgpd/identifiants/${id}/demander`, payload),
  acte: (id, payload) => api.post(`/rgpd/identifiants/${id}/acte`, payload),
  opposer: (id, payload) => api.post(`/rgpd/identifiants/${id}/opposer`, payload),
  personne: (id, payload) => api.patch(`/rgpd/identifiants/${id}/personne`, payload),
  relation: (id, payload) => api.patch(`/rgpd/relations/${id}`, payload),
  campagnes: () => api.get('/rgpd/campagnes'),
  campagne: (id) => api.get(`/rgpd/campagnes/${id}`),
  creerCampagne: (c) => api.post('/rgpd/campagnes', c),
  modifierCampagne: (id, c) => api.patch(`/rgpd/campagnes/${id}`, c),
  cibleCampagne: (id) => api.get(`/rgpd/campagnes/${id}/cible`),
  lancerCampagne: (id, max) => api.post(`/rgpd/campagnes/${id}/lancer`, { max }),
  mentions: () => api.get('/rgpd/mentions'),
  creerMention: (m) => api.post('/rgpd/mentions', m),
  journal: (params) => api.get('/rgpd/journal', { params }),
  sceaux: () => api.get('/rgpd/sceaux'),
  exporter: (params) => api.get('/rgpd/export', { params, responseType: 'blob' }),
  config: () => api.get('/rgpd/config'),
  modifierSociete: (id, s) => api.patch(`/rgpd/societes/${id}`, s),
  creerSociete: (s) => api.post('/rgpd/societes', s),
  modifierFinalite: (code, f) => api.patch(`/rgpd/finalites/${code}`, f),
  creerCle: (c) => api.post('/rgpd/cles', c),
  modifierCle: (id, actif) => api.patch(`/rgpd/cles/${id}`, { actif }),
  creerHabilitation: (h) => api.post('/rgpd/habilitations', h),
  modifierHabilitation: (id, h) => api.patch(`/rgpd/habilitations/${id}`, h),
  importer: (payload) => api.post('/rgpd/import', payload),
  apercuImport: () => api.get('/rgpd/import/apercu'),
  etatImport: () => api.get('/rgpd/import/etat'),
  tache: (nom) => api.post(`/rgpd/taches/${nom}`),
};

// Pages publiques (sans jeton).
const pub = axios.create({ baseURL: '/api/public' });
export const publique = {
  formulaire: (token) => pub.get(`/c/${token}`),
  repondre: (token, reponses) => pub.post(`/c/${token}`, { reponses }),
  retrait: (token) => pub.get(`/r/${token}`),
  retirer: (token, finalites) => pub.post(`/r/${token}`, finalites ? { finalites } : {}),
  preuve: (token) => pub.get(`/p/${token}`),
};

export function telechargerBlob(data, nom) {
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = nom;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export default api;
